import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { SerializableNativeUiVaultConfig } from 'src/@types/vaults';
import { UiVaults } from 'src/constants/vaults';
import { useVaultsStore } from 'src/stores/vaultsStore/useVaultsStore';
import { vaultQueryKeys } from '../vaultQueryKeys';

async function fetchVaultConfigs(): Promise<SerializableNativeUiVaultConfig[]> {
	const response = await fetch('/api/vaults/configs');

	if (!response.ok) {
		throw new Error(`Failed to fetch vault configs: ${response.status}`);
	}

	return response.json();
}

export function useVaultConfigs() {
	const query = useQuery({
		queryKey: vaultQueryKeys.vaultConfigs(),
		queryFn: fetchVaultConfigs,
		staleTime: Infinity,
	});

	useEffect(() => {
		if (query.data) {
			UiVaults.setVaultsClientSide(query.data);
			useVaultsStore.getState().set((s) => {
				s.areVaultConfigsLoaded = true;
			});
		} else if (query.isError) {
			UiVaults.error = true;
			UiVaults.setVaultsClientSide([]);
		}
	}, [query.data, query.isError]);

	return query;
}
